export const MEMBERSHIP_AREAS = ["catalog", "sales", "finance"] as const;
export type MembershipArea = (typeof MEMBERSHIP_AREAS)[number];

export const AREA_LABELS: Record<MembershipArea, string> = {
  catalog: "Catálogo",
  sales: "Vendas",
  finance: "Financeiro",
};

const NAV_AREA: Record<string, MembershipArea> = {
  "/orders": "sales",
  "/fulfillment": "sales",
  "/questions": "sales",
  "/messages": "sales",
  "/claims": "sales",
  "/listings": "catalog",
  "/stock": "catalog",
  "/purchases": "catalog",
  "/demand": "catalog",
  "/profit": "finance",
  "/dashboard": "finance",
};

export function normalizeAreas(
  value: readonly string[] | null | undefined,
): MembershipArea[] | null {
  if (!value?.length) return null;
  const unique = [
    ...new Set(
      value.filter((item): item is MembershipArea =>
        (MEMBERSHIP_AREAS as readonly string[]).includes(item),
      ),
    ),
  ];
  if (unique.length === 0 || unique.length === MEMBERSHIP_AREAS.length) {
    return null;
  }
  return unique;
}

export function canAccessArea(input: {
  role?: string | null;
  areas?: readonly string[] | null;
  area: MembershipArea;
}) {
  if (input.role === "owner" || input.role === "admin") return true;
  const areas = normalizeAreas(input.areas);
  if (!areas) return true;
  return areas.includes(input.area);
}

export function canAccessNav(input: {
  role?: string | null;
  areas?: readonly string[] | null;
  to: string;
}) {
  const area = NAV_AREA[input.to];
  if (!area) return true;
  return canAccessArea({ ...input, area });
}

export function areaForWebPath(pathname: string): MembershipArea | null {
  if (pathname === "/demand" || pathname.startsWith("/demand/")) return "catalog";
  if (pathname === "/profit" || pathname.startsWith("/profit/")) return "finance";
  if (pathname === "/dashboard" || pathname.startsWith("/dashboard/"))
    return "finance";
  if (pathname.startsWith("/listings")) return "catalog";
  if (pathname.startsWith("/stock")) return "catalog";
  if (pathname.startsWith("/purchases")) return "catalog";
  if (pathname.startsWith("/orders")) return "sales";
  if (pathname.startsWith("/fulfillment")) return "sales";
  if (pathname.startsWith("/questions")) return "sales";
  if (pathname.startsWith("/messages")) return "sales";
  if (pathname.startsWith("/claims")) return "sales";
  return null;
}

export function canAccessWebPath(input: {
  role?: string | null;
  areas?: readonly string[] | null;
  pathname: string;
}) {
  const area = areaForWebPath(input.pathname);
  if (!area) return true;
  return canAccessArea({ ...input, area });
}

export function formatAreas(areas: readonly string[] | null | undefined) {
  const normalized = normalizeAreas(areas);
  if (!normalized) return "Tudo";
  return normalized.map((area) => AREA_LABELS[area]).join(" · ");
}
